import React from "react";
import Navegacion from './components/Navegacion';
import './App.css';
import Footer from './components/Footer';
const Services = () => {
    return (
        <div className="App">
            <Navegacion whereIam='service'/>
            <Footer />
        </div>
    )
}

export default Services;